import { type FC } from 'react'
import classNames from 'classnames'
import styles from './MeetingInsights.module.scss'
import { MeetingInsightsCard } from './MeetingInsightsCard'
import { ADVISOR_INSIGHTS_TIME_RANGE, TIME_RANGE_LABELS } from '../../../../../../shared/insights'

const SKELETON_ROW_COUNT = 3

const SkeletonRow: FC = () => {
  return (
    <div className='d-flex align-items-center zocks-gap-0.75'>
      <div className={classNames('skeleton flex-shrink-0 zocks-border-0.5', styles.iconBox)} />
      <div className={classNames('skeleton flex-1 mw-0 zocks-border-0.25', styles.skeletonText)} />
    </div>
  )
}

export const MeetingInsightsSkeleton: FC = () => {
  return (
    <MeetingInsightsCard title='Insights for this meeting' subtitle={`Based on the last ${TIME_RANGE_LABELS[ADVISOR_INSIGHTS_TIME_RANGE]}`}>
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </MeetingInsightsCard>
  )
}
